var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuExpand = function SvgMenuExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8.5 7.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zM8 16a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 8 16m-2.5-4A.75.75 0 1 1 4 12a.75.75 0 0 1 1.5 0m-.75 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })));
};
export default SvgMenuExpand;